import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isIntermodalShipmentType } from '../../../../helpers/shipment-types';
import ShipmentDetailIndividualItem from './ShipmentDetailIndividualItem';
const HazmatDisplay = ({ shipment, order }) => {
    const { t } = useTranslation();
    const isIntermodalType = useMemo(() => isIntermodalShipmentType(shipment), [shipment]);
    const notApplicableText = t('N_A');
    const hazmatClass = useMemo(() => {
        var _a, _b;
        if (isIntermodalType) {
            return (_a = order === null || order === void 0 ? void 0 : order.hazmat_class) !== null && _a !== void 0 ? _a : notApplicableText;
        }
        return (_b = shipment === null || shipment === void 0 ? void 0 : shipment.hazmat_class) !== null && _b !== void 0 ? _b : notApplicableText;
    }, [isIntermodalType, order, shipment]);
    const hazmatPackagingGroup = useMemo(() => {
        var _a, _b;
        if (isIntermodalType) {
            return (_a = order === null || order === void 0 ? void 0 : order.hazmat_packaging_group) !== null && _a !== void 0 ? _a : notApplicableText;
        }
        return (_b = shipment === null || shipment === void 0 ? void 0 : shipment.hazmat_packaging_group) !== null && _b !== void 0 ? _b : notApplicableText;
    }, [isIntermodalType, order, shipment]);
    return (React.createElement(React.Fragment, null, isIntermodalType && (React.createElement(React.Fragment, null,
        React.createElement(ShipmentDetailIndividualItem, { dataTestId: "ShipmentDetailIndividualItem-651be33e", title: t('HAZMAT_CLASS'), value: hazmatClass }),
        React.createElement(ShipmentDetailIndividualItem, { dataTestId: "ShipmentDetailIndividualItem-651be34e", title: t('HAZMAT_PACKAGING_GROUP'), value: hazmatPackagingGroup })))));
};
export default HazmatDisplay;
